import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockSolutionTilesFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 * Lazy per the block-loading rule: not on the critical rendering path.
 *
 * `innerComponent` deep-imports TilesGrid rather than going through the `../Tiles`
 * barrel, which would eagerly pull that block's whole module graph back in.
 */
export const solutionTilesBlockConfig = {
  name: 'inner-block-solution-tiles',
  component: defineAsyncComponent(() => import('./CmsSolutionTiles.vue')),
  innerComponent: defineAsyncComponent(() => import('../Tiles/TilesGrid.vue')),
  fields: blockSolutionTilesFields,
} satisfies ModularBlockConfig;
